import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Typography from '@material-ui/core/Typography';
import withStyles from '@material-ui/core/styles/withStyles';
import Lock from '@material-ui/icons/LockOutlined';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: theme.spacing(1),
    width: '100%',
    height: theme.spacing(4.25),
    alignItems: 'center',
    backgroundColor: theme.palette.common.white,
  },
  secondLevel: {
    backgroundColor: theme.colors.grayBlue,
  },
  fieldName: {
    marginLeft: theme.spacing(2),
  },
  fieldNameContainer: {
    flex: 1,
  },
  iconContainer: {
    marginLeft: theme.spacing(1.5),
    width: theme.spacing(1.75),
  },
  lock: {
    color: theme.colors.gray1,
  },
});

class MockField extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    secondLevel: PropTypes.bool,
    removeSection: PropTypes.func,
    displayName: PropTypes.string,
  };

  render() {
    const { classes, secondLevel, displayName } = this.props;

    return (
      <div className={classNames(classes.root, { [classes.secondLevel]: secondLevel })}>
        <div className={classes.iconContainer}>
          <Lock className={classes.lock} />
        </div>
        <div className={classes.fieldNameContainer}>
          <Typography variant="body1" className={classes.fieldName}>
            {displayName}
          </Typography>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(MockField);
